export default "__VITE_ASSET__CZ6mt65y__"